<section id="container">
  <app-menu></app-menu>
  <section id="main-content">
    <section class="wrapper">
      <app-connection-wizard></app-connection-wizard>
    </section>
  </section>
</section>
